import React from "react";
import { BACKEND_URL } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Users, Download, Link as LinkIcon } from "lucide-react";

export function SetupCard({ onOpen }) {
  const templateUrl = `${BACKEND_URL}/api/roster/template.csv`;
  return (
    <div className="bg-surface border border-surface-3 p-8" data-testid="roster-setup">
      <div className="flex items-center gap-3 mb-4">
        <Users className="w-6 h-6 text-amber" />
        <div className="font-display text-3xl uppercase tracking-wider text-white">Set Up Your Team Roster</div>
      </div>
      <p className="text-slate-300 text-sm max-w-2xl leading-relaxed">
        Your roster lives in a Google Sheet you share with your AD. Both of you edit the sheet
        (AD clears eligibility, you mark good-to-play). When you need Gridiron OS to reflect
        the latest changes, hit <span className="text-amber font-semibold">Sync From Sheet</span> — that's it.
      </p>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
        <SetupStep n="01" title="Get the template">
          <a
            href={templateUrl}
            data-testid="download-template-btn"
            className="inline-flex items-center gap-2 text-[10px] font-condensed uppercase tracking-widest text-amber hover:underline mt-2"
          >
            <Download className="w-3 h-3" /> Download roster template (CSV)
          </a>
          <div className="text-xs text-slate-500 mt-2">Same columns Gridiron OS expects.</div>
        </SetupStep>
        <SetupStep n="02" title="Create your Google Sheet">
          <div className="text-xs text-slate-400 mt-2 leading-relaxed">
            1. In Google Drive, click <span className="text-white">New → File upload</span> and upload the CSV.<br />
            2. Right-click the file → <span className="text-white">Open with → Google Sheets</span>.<br />
            3. Click <span className="text-white">Share</span> → invite your AD as Editor.<br />
            4. Click <span className="text-white">Share</span> → change "General access" to <span className="text-white">Anyone with the link — Viewer</span>.
          </div>
        </SetupStep>
        <SetupStep n="03" title="Paste the sheet URL">
          <div className="text-xs text-slate-400 mt-2">
            Open the roster settings and paste your sheet URL. Then run your first sync.
          </div>
          <Button
            onClick={onOpen}
            data-testid="open-settings-btn"
            className="mt-3 rounded-none bg-amber hover:bg-amber-600 text-[#0B0D12] h-9 text-[10px] font-condensed uppercase tracking-widest"
          >
            <LinkIcon className="w-3 h-3 mr-1" /> Open Roster Settings
          </Button>
        </SetupStep>
      </div>
    </div>
  );
}

function SetupStep({ n, title, children }) {
  return (
    <div className="border-l-2 border-amber pl-4 py-2">
      <div className="font-display text-3xl text-amber leading-none">{n}</div>
      <div className="font-display text-lg tracking-wider text-white uppercase mt-2">{title}</div>
      {children}
    </div>
  );
}
